import { Flex } from 'foundations-components/components/Flex';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { TicketListingsSearch } from './TicketListingsSearch';
import { InboxNavSortAndFilter } from './InboxNavSortAndFilter';
import { InboxNavTicketList } from './InboxNavTicketList';
import { DEFAULT_LIMIT } from '../data/useTicketListings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InboxNavPanelBody({
  tickets,
  loading,
  total,
  offset,
  setOffset
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      paddingInline: "400",
      paddingBlockEnd: "200",
      borderBlockEndWidth: "100",
      borderBlockEndStyle: "solid",
      borderColor: "border-core-subtle",
      gap: "200",
      children: [/*#__PURE__*/_jsx(TicketListingsSearch, {
        screen: "ticket-details-inbox-nav",
        clearable: true,
        inlineSize: "100%"
      }), /*#__PURE__*/_jsx(InboxNavSortAndFilter, {})]
    }), /*#__PURE__*/_jsx(InboxNavTicketList, {
      tickets: tickets,
      loading: loading
    }), total > DEFAULT_LIMIT && /*#__PURE__*/_jsx(Paginator, {
      "data-test-id": "inbox-nav-paginator",
      marginBlockStart: "400",
      pageCount: Math.ceil(total / DEFAULT_LIMIT),
      page: Math.floor(offset / DEFAULT_LIMIT) + 1,
      maxVisiblePageButtons: 5,
      onPageChange: e => setOffset((e.target.value - 1) * DEFAULT_LIMIT)
    })]
  });
}